import React from 'react'

const ModalDeleteBoQs = ({isModalOpen, setIsModalOpen, confirmDelete}) => {  
    return (
        <div className='modales-container'>
        {isModalOpen && (
            <div className="modales-overlay">
              <div className="modales">
                <h3>¿Estás seguro de que quieres eliminar los BoQs?</h3>
                <div className="modales-actions">
                  <button onClick={confirmDelete} className="btn btn-confirm">
                    Aceptar
                  </button>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="btn btn-cancelar"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}
          </div>
    )
}
export default ModalDeleteBoQs;

